import React from "react"

import type { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { PrimaryText } from "@front-shared/elements/primaryText.element"

export const PayerStatusMessageComponent: React.FunctionComponent<
    IPayerStatusMessageComponentProps
> = props => {
    return (
        <section
            role={props.role}
            className={`flex flex-col items-center gap-[8px] rounded-[16px] bg-brand-white px-[24px] py-[48px] text-center shadow-sm ${
                props.className || ""
            }`}
        >
            <div className="grid h-[48px] w-[48px] place-items-center rounded-full bg-brand-offWhite">
                <FontAwesomeIcon icon={props.icon} />
            </div>

            <PrimaryText typography="h5">{props.title}</PrimaryText>

            <PrimaryText className="max-w-[420px] opacity-60">
                {props.text}
            </PrimaryText>

            <div className="mt-[8px] flex flex-wrap justify-center gap-[8px]">
                {props.children}
            </div>
        </section>
    )
}

interface IPayerStatusMessageComponentProps {
    className?: string
    role?: React.AriaRole
    icon: IconDefinition
    title: string
    text: string
    children: React.ReactNode // actions
}
